import request from '@/common/request'

class NESHService {
  getAll() {
    return request.get('/nesh')
  }

  getById(neshId) {
    return request.get(`/nesh/${neshId}`)
  }

  create(data) {
    return request.post('/nesh', data)
  }

  update(id, data) {
    return request.patch(`/nesh/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/nesh/${id}`)
  }
}

export default new NESHService()
